import type { QuillModules } from 'ngx-quill';
import { localizationKeys } from './app-localization-keys';

export const Constants = {
    ACTION_BAR: {
        ICONS: {
            ARROW_LEFT: 'arrow-left',
        },
        PREFIXES: {
            // TODO: check hardcoded
            GO_BACK_TO_KEY: 'aumico_reports_action_bar_footer_back_to',
            // GO_BACK_TO: 'Go back to',
            PROCEED_TO_KEY: 'aumico_reports_action_bar_footer_proceed_to',
            // PROCEED_TO: 'Proceed to',
        },
        LABELS: {
            GENERAL_INFORMATION_KEY:
                localizationKeys.aumico_reports_annualreport_page_financial_statement_general_information_label_general_information,
            IMPORT_BALANCE_SHEET_KEY: localizationKeys.aumico_reports_annualreport_navigation_import,
            FINANCIAL_CLOSING_PROCESS_KEY: localizationKeys.aumico_reports_annualreport_navigation_fcp,
            UPLOAD_BALANCE_SHEET_KEY: localizationKeys.aumico_reports_annualreport_navigation_import_upload,
            ACCOUNT_MAPPING_KEY: localizationKeys.aumico_reports_annualreport_navigation_import_mapping,
            GROUPING_MASKING_KEY: localizationKeys.aumico_reports_annualreport_navigation_import_grouping_masking,
            CASH_FLOW_KEY: localizationKeys.aumico_reports_annualreport_navigation_cfs,
            NOTES_KEY: localizationKeys.aumico_reports_annualreport_navigation_notes,
            APPROPRIATION_OF_PROFIT_KEY: localizationKeys.aumico_reports_annualreport_navigation_aop,
            ADJUSTMENTS_AND_RECLASSES:
                localizationKeys.aumico_reports_annualreport_navigation_adjustments_and_reclasses,
            EQUITY_MOVEMENT_SCHEDULE: localizationKeys.aumico_reports_annualreport_navigation_equity_movement_schedule,
            COMPLEMENTARY_REPORTS: localizationKeys.aumico_reports_annualreport_navigation_complementary_reports,
            FINISH_AND_PRINT_KEY: localizationKeys.aumico_reports_annualreport_navigation_finish_and_print,
            PRINT_STEP_LABEL: localizationKeys.aumico_annual_report_print_only,
        },
    },

    ERROR_DIALOG: {
        SOMETHING_WENT_WRONG: localizationKeys.aumico_reports_error_dialog_something_went_wrong,
        BAD_REQUEST: localizationKeys.aumico_reports_error_dialog_bad_request,
        FIRST_AND_LAST_NAMES_REQUIRED:
            localizationKeys.aumico_reports_error_dialog_bad_request_first_and_last_names_required,
        PHONE_NUMBER_INVALID: localizationKeys.aumico_reports_error_dialog_bad_request_phone_number_invalid,
    },

    translationKeys: {
        printButtonLabelTranslationKey: 'aumico_annual_report_print_options_print',
    },

    GERMANY_ISO_3166_1_ALPHA_2_COUNTRY_CODE: 'DE',
    SIDE_NAV_STATE_COLLAPSED_KEY: 'side-nav-state-collapsed',
};

export const DEFAULT_VISIBLE_PAGES_RANGE = 7;
export const USER_INPUT_DEBOUNCE_TIME = 500;
export const SWL_WARNING_MESSAGE_BUTTON_COLOR = '#221c26';
export const SWL_WARNING_MESSAGE_INFO_ICON = 'info';
export const DEFAULT_NOTIFICATION_AUTO_HIDE_DELAY = 4000;

export const TWO_DECIMAL_PLACES = 2;
export const NO_DECIMAL_PLACES = 0;
export const ARRAY_SIZE_OF_TWO_ELEMENTS = 2;
export const ARRAY_SIZE_OF_ONE_ELEMENT = 1;
export const FIRST_ELEMENT_INDEX = 0;
export const SECOND_ELEMENT_INDEX = 1;
export const THOUSANDS_SEPARATOR = "['’]";

export const EMPTY_ARRAY_LENGTH = 0;
export const EMPTY_STRING = '';
export const MULTIPLIER_FOR_PERCENTAGE = 100;
export const MAT_DIALOG_CUSTOM_CLASS = 'custom-popup-information';

export const RICH_TEXT_TOOL_BAR_OPTIONS: QuillModules = {
    toolbar: [
        [{ font: [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', { color: [] }, { background: [] }],
        [{ align: [] }, { list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['clean', 'strike', 'blockquote'],
    ],
};

const SWITZERLAND_COUNTRY_ISO31661_ALPHA2_CODE = 'CH';
export const DEFAULT_COUNTRY_ISO31661_ALPHA2_CODE = SWITZERLAND_COUNTRY_ISO31661_ALPHA2_CODE;

export const DEFAULT_LANGUAGE = 'de-ch';

export const GERMAN_PRIVACY_POLICY_URL = 'https://aumico.io/datenschutz/';
export const DIFFERENT_LANGUAGE_PRIVACY_POLICY_URL = 'https://aumico.io/datenschutz/';
export const GERMAN_TERMS_AND_CONDITIONS_URL = 'https://aumico.io/agb/';
export const DIFFERENT_LANGUAGE_TERMS_AND_CONDITIONS_URL = 'https://aumico.io/agb/';
export const GERMAN_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL = 'https://aumico.io/agb/';
export const DIFFERENT_LANGUAGE_AGREEMENT_ON_ORDER_DATA_PROCESSING_URL = 'https://aumico.io/agb/';
export const GERMAN_PRICES_URL = 'https://aumico.io/preise/';
export const DIFFERENT_LANGUAGE_PRICES_URL = 'https://aumico.io/preise/';

export const SUPPORTED_PLACE_HOLDERS = [
    '@org.name',
    '@user.name',
    '@ar.company',
    '@ar.duedate',
    '@ar.duedate-of-previous-year',
    '@ar.period',
    '@ar.period-of-previous-year',
    '@ar.currency',
    '@ar.assets',
    '@ar.liabilities',
    '@ar.assets-of-previous-year',
    '@ar.liabilities-of-previous-year',
    '@ar.profit',
    '@ar.profit-of-previous-year',
    '@aop.snapshot',
    '@aop.snapshot-current-year',
    '@org.street',
    '@org.addition-to-address',
    '@org.zip-code',
    '@org.city',
    '@org.country',
    '@ar.signatory1',
    '@ar.signatory2',
    '@ar.place-of-signing',
    '@ar.date-of-signing',
    '@ar.year',
    '@ar.previous-year',
    // FX (REV-21512): resolve to '' on non-FX reports / while rates are missing — never gated.
    '@ar.display-currency',
    '@ar.closing-rate',
    '@ar.closing-rate-of-previous-year',
    '@ar.average-rate',
    '@ar.average-rate-of-previous-year',
    '@company.name',
    '@company.street',
    '@company.addition-to-address',
    '@company.zip-code',
    '@company.city',
    '@company.country',
    '@company.vat-id',
    '@today',
];
